import { useEffect, useState } from 'react';
import useUserApi, { ErrorHandler } from '../Services/UserApi';
import { EftposDepositAccount } from 'shared-components';

export default function useEftposDepositAccounts() {
	const [eftposDepositAccounts, setEftposDepositAccounts] = useState<EftposDepositAccount[]>();

	const userApi = useUserApi();

	useEffect(() => {
		userApi<{ eftposDepositAccounts: EftposDepositAccount[] }>({
			route: `eftpos/api`,
			data: {
				action: 'getEftposDepositAccounts',
			},
			errorMessage: 'Error loading eftpos deposit accounts',
		})
			.then((res) => {
				setEftposDepositAccounts(
					res.data.eftposDepositAccounts.map((x) => ({
						...x,
						EftposDepositAccountAccount: (x.EftposDepositAccountAccount ?? '').replace(/ /g, ''),
						EftposDepositAccountBsb: (x.EftposDepositAccountBsb ?? '').replace(/ /g, ''),
					})),
				);
			})
			.catch((e: unknown) => ErrorHandler.toast(e));
	}, [userApi]);

	return eftposDepositAccounts;
}
